import { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
//import Select from 'react-select';

import { editarBreadcrumb } from '../../actions/breadcrumb';
//import { setAlert } from '../../actions/alert';
import { crearProveedor } from '../../actions/proveedores';

const NuevoProveedor = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Proveedores',
            path: '/proveedores'
        },
        {
            activo: true,
            nombre: 'Nuevo proveedor',
            path: '/proveedores/nuevo'
        }
    ];

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [ProveedorData, setProveedorData] = useState({
        nombre: '',
        correo: '',
        direccion: '',
        telefono: '',
        rfc: '',
        contacto: ''
    });
    

    /* Nuevo usuario */
    const handleInputChange = ({ target }) => {
        setProveedorData({
            ...ProveedorData,
            [target.name]: target.value
        });
    }

    const handleGuardarProveedor = async () => {
        await dispatch(crearProveedor(ProveedorData));
        await navigate("/proveedores");
    }

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);  

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Nuevo Proveedor</h3>
                
                    <div className="row">
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={ProveedorData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Correo" id="email" name="correo" value={ProveedorData.correo} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="email">Correo</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Dirección" id="direccion" name="direccion" value={ProveedorData.direccion} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="direccion">Dirección</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Teléfono" id="telefono" name="telefono" value={ProveedorData.telefono} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="telefono">Teléfono</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="RFC" id="rfc" name="rfc" value={ProveedorData.rfc} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="rfc">RFC</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Contacto" id="contacto" name="contacto" value={ProveedorData.contacto} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="contacto">Contacto</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <button className="btn btn-success float-end" onClick={handleGuardarProveedor}>Guardar</button>
                            <Link to='/proveedores'><button className="btn btn-danger float-end me-2">Cancelar</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default NuevoProveedor;